import { InputField } from '@atoms/input';
import BlockBase from '@components/dnd/base/blockBase';
import { Column } from '@components/dnd/base/blockBase/body.block.style';
import { useAtom } from '@hooks/useAtom';
import EndControlsFB, {
  type SettingsConfig
} from '@library/formBuilder/endControls';
import { type DNDBlock, ResolvedVariableType } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';
import type { ChangeEvent } from 'react';
import { useParams } from 'react-router-dom';
import { ParamsList } from '@/routes/routes.types';

import { initialTextFieldData } from './textField.data';
import { TextFieldModal } from './textField.modal';
import { TextFieldIcon } from './textField.utils';

const TextField = (block: DNDBlock) => {
  const actionId = useParams()[ParamsList.ActionId] as string;

  const atom = useAtom({
    type: 'TextField',
    sourceId: block.id,
    parentId: actionId,
    parentKind: 'form_action',
    initialData: initialTextFieldData,
    variableInfo: {
      resolvedType: ResolvedVariableType.Text
    }
  });

  if (!atom) {
    return null;
  }

  const getSettingsModal = (): SettingsConfig => ({
    title: atom.data.title || 'TextField title',
    content: <TextFieldModal atom={atom} />
  });

  const getEndControls = () => (
    <EndControlsFB
      dataItem={atom}
      dndBlock={block}
      hasRequired
      settings={getSettingsModal()}
    />
  );

  return (
    <BlockBase
      dataItem={atom}
      dndBlock={block}
      endControls={getEndControls()}
      icon={TextFieldIcon}
      title={atom.data.title}
    >
      <Column>
        <InputField
          label="Field title"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            atom.data.title = e.target.value;
          }}
          placeholder="Aa"
          required
          value={atom.data.title}
        />
      </Column>

      <Column>
        <InputField
          label="Placeholder"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            atom.data.placeholder = e.target.value;
          }}
          placeholder="Aa"
          value={atom.data.placeholder}
        />
      </Column>

      {/* // ! Removed validation since not implemented */}
      {/* <Column $width="170px">
        <SelectField
          label="Validation"
          value={atom.data.validation}
          onChange={(_, value) => {
            if (!value) return;
            atom.data.validation = value as ValidationOption;
          }}
        >
          {validationOptions.map(({ value, label, Icon }, index) => (
            <Option key={index} value={value} label={label}>
              {Icon}
              {label}
            </Option>
          ))}
        </SelectField>
      </Column> */}
    </BlockBase>
  );
};

export default observer(TextField);
